import * as React from 'react'

import { ChevronDownIcon, GlobeIcon } from 'lucide-react'
import { observer } from 'mobx-react'

import { Button } from '~/client/src/shared/components/Button/Button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '~/client/src/shared/components/shadcn-ui/dropdown-menu'
import Language from '~/client/src/shared/localization/Language'
import Localization from '~/client/src/shared/localization/LocalizationManager'

export const LanguageSelect = observer(function LanguageSelect() {
  if (!Localization.shouldShowLanguageSelector) {
    return null
  }

  const { currentLanguage } = Localization.state

  return (
    <DropdownMenu>
      <DropdownMenuTrigger render={<Button variant="ghost" />}>
        <GlobeIcon className="tw:text-muted-foreground" />
        <span className="tw:sr-only">{Localization.translator.language}</span>
        {currentLanguage}
        <ChevronDownIcon className="tw:text-muted-foreground" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuRadioGroup
          value={currentLanguage}
          onValueChange={(language: Language) =>
            Localization.setLanguage(language)
          }
        >
          {Localization.getLanguageOptions().map(language => (
            <DropdownMenuRadioItem key={language} value={language} closeOnClick>
              {language}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
})
